// extracted by mini-css-extract-plugin
export default {"balanceCol":"vault-balance-detail_balanceCol__zhBDh"};